import React from 'react';
import styled, { css } from 'styled-components';
import { tagStyles, variantStyles } from './styles';
import { multilineEllipsis } from '../../../styled/common';
import { DynamicTypographyProps, TagKey } from './types';

const TAG_VARIANTS: string[] = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p'];

export const DynamicTypography = styled(
  ({
    tag,
    variant,
    children,
    hover,
    styles,
    $lineToShow,
    ...props
  }: DynamicTypographyProps) => {
    const Tag = (
      TAG_VARIANTS.includes(tag as string) ? tag : 'span'
    ) as React.ElementType<React.HTMLAttributes<HTMLElement>>;
    return <Tag {...props}>{children}</Tag>;
  }
)<DynamicTypographyProps>`
  transition: color 0.2s ease-in-out;
  font-family: ${({ theme }) => theme.fontFamily};
  color: ${({ theme, color }) =>
    theme.colors.text[(color as keyof typeof theme.colors.text) || 'primary']};

  ${({ tag }) => tagStyles[(tag as TagKey) || 'default']};
  ${({ variant }) => (variant ? variantStyles[variant] : css``)};
  ${({ $lineToShow }) =>
    $lineToShow && multilineEllipsis({ linesToShow: $lineToShow })};

  &:hover {
    color: ${({ hover }) => hover};
  }

  ${({ styles }) => styles}
`;
